import type { AppRouteRecordRaw } from '@/router/types'
import { Layout } from '@/utils/routerHelper'
/** SCRM canonical page routes; menu visibility and permissions still come from system_menu. */
const scrmRoutes: AppRouteRecordRaw[] = [
  {
    path: '/scrm',
    component: Layout,
    name: 'ScrmPages',
    meta: { hidden: true },
    children: [
      {
        path: 'dashboard',
        name: 'ScrmDashboard',
        component: () => import('@/views/scrm/dashboard/index.vue'),
        meta: { hidden: true, canTo: true, title: '概况' }
      },
      {
        path: 'live-code',
        name: 'ScrmLiveCode',
        component: () => import('@/views/scrm/live-code/index.vue'),
        meta: { hidden: true, canTo: true, title: '渠道活码' }
      },
      {
        path: 'fission',
        name: 'ScrmFission',
        component: () => import('@/views/scrm/fission/index.vue'),
        meta: { hidden: true, canTo: true, title: '裂变任务' }
      },
      {
        path: 'group-code',
        name: 'ScrmGroupCode',
        component: () => import('@/views/scrm/group-code/index.vue'),
        meta: { hidden: true, canTo: true, title: '进群宝' }
      },
      {
        path: 'add-friend',
        name: 'ScrmAddFriend',
        component: () => import('@/views/scrm/add-friend/index.vue'),
        meta: { hidden: true, canTo: true, title: '批量加好友' }
      },
      {
        path: 'red-packet',
        name: 'ScrmRedPacket',
        component: () => import('@/views/scrm/red-packet/index.vue'),
        meta: { hidden: true, canTo: true, title: '红包获客' }
      },
      {
        path: 'customer',
        name: 'ScrmCustomer',
        component: () => import('@/views/scrm/customer/index.vue'),
        meta: { hidden: true, canTo: true, title: '客户管理' }
      },
      {
        path: 'mass-send',
        name: 'ScrmMassSend',
        component: () => import('@/views/scrm/mass-send/index.vue'),
        meta: { hidden: true, canTo: true, title: '消息群发' }
      },
      {
        path: 'tag',
        name: 'ScrmTag',
        component: () => import('@/views/scrm/tag/index.vue'),
        meta: { hidden: true, canTo: true, title: '客户标签' }
      },
      {
        path: 'loss',
        name: 'ScrmLoss',
        component: () => import('@/views/scrm/loss/index.vue'),
        meta: { hidden: true, canTo: true, title: '流失客户' }
      },
      {
        path: 'moments',
        name: 'ScrmMoments',
        component: () => import('@/views/scrm/moments/index.vue'),
        meta: { hidden: true, canTo: true, title: '历史朋友圈' }
      },
      {
        path: 'welcome',
        name: 'ScrmWelcome',
        component: () => import('@/views/scrm/welcome/index.vue'),
        meta: { hidden: true, canTo: true, title: '欢迎语' }
      },
      {
        path: 'assistant',
        name: 'ScrmAssistant',
        component: () => import('@/views/scrm/assistant/index.vue'),
        meta: { hidden: true, canTo: true, title: '企微助手' }
      },
      {
        path: 'violation',
        name: 'ScrmViolation',
        component: () => import('@/views/scrm/violation/index.vue'),
        meta: { hidden: true, canTo: true, title: '违规词提醒' }
      },
      {
        path: 'radar',
        name: 'ScrmRadar',
        component: () => import('@/views/scrm/radar/index.vue'),
        meta: { hidden: true, canTo: true, title: '互动雷达' }
      },
      {
        path: 'radar-packet',
        name: 'ScrmRadarPacket',
        component: () => import('@/views/scrm/radar-packet/index.vue'),
        meta: { hidden: true, canTo: true, title: '互动红包' }
      },
      {
        path: 'stage',
        name: 'ScrmStage',
        component: () => import('@/views/scrm/stage/index.vue'),
        meta: { hidden: true, canTo: true, title: '客户阶段' }
      },
      {
        path: 'sop',
        name: 'ScrmSop',
        component: () => import('@/views/scrm/sop/index.vue'),
        meta: { hidden: true, canTo: true, title: '个人SOP' }
      },
      {
        path: 'moments-show',
        name: 'ScrmMomentsShow',
        component: () => import('@/views/scrm/moments-show/index.vue'),
        meta: { hidden: true, canTo: true, title: '朋友圈展示' }
      },
      {
        path: 'material',
        name: 'ScrmMaterial',
        component: () => import('@/views/scrm/material/index.vue'),
        meta: { hidden: true, canTo: true, title: '素材库' }
      },
      {
        path: 'sms',
        name: 'ScrmSms',
        component: () => import('@/views/scrm/sms/index.vue'),
        meta: { hidden: true, canTo: true, title: '短信群发' }
      },
      {
        path: 'custom',
        name: 'ScrmCustom',
        component: () => import('@/views/scrm/customField/index.vue'),
        meta: { hidden: true, canTo: true, title: '自定义信息' }
      },
      {
        path: 'auto-tag',
        name: 'ScrmAutoTag',
        component: () => import('@/views/scrm/auto-tag/index.vue'),
        meta: { hidden: true, canTo: true, title: '自动打标签' }
      },
      {
        path: 'del-alert',
        name: 'ScrmDelAlert',
        component: () => import('@/views/scrm/del-alert/index.vue'),
        meta: { hidden: true, canTo: true, title: '删人提醒' }
      },
      {
        path: 'article',
        name: 'ScrmArticle',
        component: () => import('@/views/scrm/article/index.vue'),
        meta: { hidden: true, canTo: true, title: '图文管理' }
      },
      {
        path: 'group-send',
        name: 'ScrmGroupSend',
        component: () => import('@/views/scrm/group-send/index.vue'),
        meta: { hidden: true, canTo: true, title: '群消息群发' }
      },
      {
        path: 'auto-group',
        name: 'ScrmAutoGroup',
        component: () => import('@/views/scrm/auto-group/index.vue'),
        meta: { hidden: true, canTo: true, title: '自动拉群' }
      },
      {
        path: 'group',
        name: 'ScrmGroup',
        component: () => import('@/views/scrm/group/index.vue'),
        meta: { hidden: true, canTo: true, title: '群列表' }
      },
      {
        path: 'group-data',
        name: 'ScrmGroupData',
        component: () => import('@/views/scrm/group-data/index.vue'),
        meta: { hidden: true, canTo: true, title: '群数据' }
      },
      {
        path: 'group-alert',
        name: 'ScrmGroupAlert',
        component: () => import('@/views/scrm/group-alert/index.vue'),
        meta: { hidden: true, canTo: true, title: '客户群提醒' }
      },
      {
        path: 'group-welcome',
        name: 'ScrmGroupWelcome',
        component: () => import('@/views/scrm/group-welcome/index.vue'),
        meta: { hidden: true, canTo: true, title: '群欢迎语' }
      },
      {
        path: 'tag-group',
        name: 'ScrmTagGroup',
        component: () => import('@/views/scrm/tag-group/index.vue'),
        meta: { hidden: true, canTo: true, title: '标签建群' }
      },
      {
        path: 'group-sop',
        name: 'ScrmGroupSop',
        component: () => import('@/views/scrm/group-sop/index.vue'),
        meta: { hidden: true, canTo: true, title: '群SOP' }
      },
      {
        path: 'group-stats',
        name: 'ScrmGroupStats',
        component: () => import('@/views/scrm/group-stats/index.vue'),
        meta: { hidden: true, canTo: true, title: '群数据统计' }
      },
      {
        path: 'group-tag',
        name: 'ScrmGroupTag',
        component: () => import('@/views/scrm/group-tag/index.vue'),
        meta: { hidden: true, canTo: true, title: '群标签' }
      },
      {
        path: 'wecom',
        name: 'ScrmWeCom',
        component: () => import('@/views/scrm/wecom/index.vue'),
        meta: { hidden: true, canTo: true, title: '企微设置' }
      },
      {
        path: 'contact',
        name: 'ScrmContact',
        component: () => import('@/views/scrm/contact/index.vue'),
        meta: { hidden: true, canTo: true, title: '通讯录' }
      },
      {
        path: 'chat-archive',
        name: 'ScrmChatArchive',
        component: () => import('@/views/scrm/chat-archive/index.vue'),
        meta: { hidden: true, canTo: true, title: '会话存档' }
      },
      {
        path: 'copyright',
        name: 'ScrmCopyright',
        component: () => import('@/views/scrm/copyright/index.vue'),
        meta: { hidden: true, canTo: true, title: '版权设置' }
      },
      {
        path: 'staff-stats',
        name: 'ScrmStaffStats',
        component: () => import('@/views/scrm/staff-stats/index.vue'),
        meta: { hidden: true, canTo: true, title: '成员统计' }
      },
      {
        path: 'auth',
        name: 'ScrmAuth',
        component: () => import('@/views/scrm/auth/index.vue'),
        meta: { hidden: true, canTo: true, title: '授权管理' }
      },
      {
        path: 'account',
        name: 'ScrmAccount',
        component: () => import('@/views/scrm/account/index.vue'),
        meta: { hidden: true, canTo: true, title: '账户中心' }
      },
      {
        path: 'sub-account',
        name: 'ScrmSubAccount',
        component: () => import('@/views/scrm/sub-account/index.vue'),
        meta: { hidden: true, canTo: true, title: '子账户' }
      },
      {
        path: 'app-config',
        name: 'ScrmAppConfig',
        component: () => import('@/views/scrm/app-config/index.vue'),
        meta: { hidden: true, canTo: true, title: '应用配置' }
      },
      {
        path: 'quick-reply',
        name: 'ScrmQuickReply',
        component: () => import('@/views/scrm/quick-reply/index.vue'),
        meta: { hidden: true, canTo: true, title: '快捷回复' }
      },
      {
        path: 'portrait',
        name: 'ScrmPortrait',
        component: () => import('@/views/scrm/portrait/index.vue'),
        meta: { hidden: true, canTo: true, title: '客户画像' }
      },
      {
        path: 'one-code',
        name: 'ScrmOneCode',
        component: () => import('@/views/scrm/one-code/index.vue'),
        meta: { hidden: true, canTo: true, title: '一客一码' }
      },
      {
        path: 'ops',
        name: 'ScrmOps',
        component: () => import('@/views/scrm/ops/index.vue'),
        meta: { hidden: true, canTo: true, title: '运营工具' }
      },
      {
        path: 'order',
        name: 'ScrmOrder',
        component: () => import('@/views/scrm/order/index.vue'),
        meta: { hidden: true, canTo: true, title: '第三方订单' }
      },
      {
        path: 'notice',
        name: 'ScrmNotice',
        component: () => import('@/views/scrm/notice/index.vue'),
        meta: { hidden: true, canTo: true, title: '公告' }
      },
      {
        path: 'robot-rule',
        name: 'ScrmRobotRule',
        component: () => import('@/views/scrm/robot/rule.vue'),
        meta: { hidden: true, canTo: true, title: '机器人规则' }
      },
      {
        path: 'robot-log',
        name: 'ScrmRobotLog',
        component: () => import('@/views/scrm/robot/log.vue'),
        meta: { hidden: true, canTo: true, title: '机器人日志' }
      },
      {
        path: 'customer/:id',
        name: 'ScrmCustomerDetail',
        component: () => import('@/views/scrm/customer/detail.vue'),
        meta: {
          title: '客户详情',
          hidden: true,
          noCache: true,
          activeMenu: '/scrm/customer-contact/customer'
        }
      }
    ]
  }
]
export default scrmRoutes
